import script from "./ResetView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetView.vue?vue&type=script&setup=true&lang=js"

import "./ResetView.vue?vue&type=style&index=0&id=f4e2fc48&lang=css"

const __exports__ = script;

export default __exports__